import React from "react";
import "./PublicHome.css";

const products = [
  {
    eyebrow: "VPN",
    title: "HAPP, V2Ray и WireGuard",
    text: "Один аккаунт SimolApps для подключения VPN на телефоне и компьютере. Инструкции и варианты подключения собраны в одном месте.",
    href: "/vpn/",
    link: "Подробнее о VPN",
  },
  {
    eyebrow: "Финансы",
    title: "Учёт денег и малого бизнеса",
    text: "Доходы, расходы, счета, бюджеты, аналитика и заказы в веб-кабинете и Android-приложении.",
    href: "/finansi/",
    link: "Подробнее о финансах",
  },
];

export default function PublicHome() {
  return (
    <main className="public-home">
      <header className="public-home__nav">
        <a className="public-home__brand" href="/" aria-label="SimolApps — главная">
          <img src="/logo192.png" alt="" width="42" height="42" />
          <span><strong>SimolApps</strong><small>сервисы и приложения</small></span>
        </a>
        <nav aria-label="Основная навигация">
          <a href="/vpn/">VPN</a>
          <a href="/finansi/">Финансы</a>
          <a className="public-home__login" href="/register">Войти</a>
        </nav>
      </header>

      <section className="public-home__hero">
        <p className="public-home__eyebrow">SIMOLAPPS</p>
        <h1>VPN и полезные приложения в одном аккаунте</h1>
        <p className="public-home__lead">
          Подключайте VPN через HAPP, V2Ray или WireGuard и ведите личные либо
          бизнес-финансы в приложениях SimolApps.
        </p>
        <div className="public-home__actions">
          <a className="public-home__primary" href="/register">Войти или зарегистрироваться</a>
          <a className="public-home__secondary" href="/vpn/">Выбрать VPN-подключение</a>
        </div>
      </section>

      <section className="public-home__products" aria-labelledby="products-title">
        <div className="public-home__section-heading">
          <p className="public-home__eyebrow">ВОЗМОЖНОСТИ</p>
          <h2 id="products-title">Два направления SimolApps</h2>
        </div>
        <div className="public-home__grid">
          {products.map((product) => (
            <article className="public-home__card" key={product.href}>
              <span>{product.eyebrow}</span>
              <h3>{product.title}</h3>
              <p>{product.text}</p>
              <a href={product.href}>{product.link} <span aria-hidden="true">→</span></a>
            </article>
          ))}
        </div>
      </section>

      <section className="public-home__details" aria-labelledby="why-title">
        <div>
          <p className="public-home__eyebrow">ОДИН ПРОФИЛЬ</p>
          <h2 id="why-title">С телефона и через веб</h2>
        </div>
        <ul>
          <li><strong>VPN:</strong> инструкции для iOS, Android и Windows.</li>
          <li><strong>WireGuard:</strong> отдельные профили для доступных серверов.</li>
          <li><strong>HAPP / V2Ray:</strong> ссылка подписки для совместимых клиентов.</li>
          <li><strong>Финансы:</strong> веб-кабинет и Android-приложение с едиными данными.</li>
        </ul>
      </section>

      <footer className="public-home__footer">
        <span>© SimolApps</span>
        <a href="/register">Личный кабинет</a>
      </footer>
    </main>
  );
}
